import { render, staticRenderFns } from "./AutoReplyPanel.vue?vue&type=template&id=3347f880&scoped=true"
import script from "./AutoReplyPanel.vue?vue&type=script&lang=js"
export * from "./AutoReplyPanel.vue?vue&type=script&lang=js"
import style0 from "./AutoReplyPanel.vue?vue&type=style&index=0&id=3347f880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347f880",
  null
  
)

export default component.exports